export default __webpack_public_path__ + "static/media/higherdividend-graph.904b6b13.png";